// Vendors
import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useProofIncomeContextConsumerHook } from 'containers/proof-income/contexts/proof-income.context';
// Event Handlers
import { ProofIncomeLandingHandlers } from '../handlers/proof-income-landing.handlers';
import { ProofIncomeLandingTrackingHandlers } from '../handlers/proof-income-landing.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { ProofIncomeLandingHookType } from './types/proof-income-landing.hook.type';

const useProofIncomeLandingHook = (): ProofIncomeLandingHookType => {
  const { flowApiData } = useLayoutContextConsumerHook(),
    {
      setIframeUrl,
      setProofIncomeIdentificationId,
      setSelectedMethod,
      setProofIncomeState,
      selectedMethod,
    } = useProofIncomeContextConsumerHook(),
    { methods = [] } = flowApiData || {};

  const { showBoundary: setError } = useErrorBoundary();

  const {
    handleTrackView,
    handleTrackConfirm,
    handleTrackSelectMethod,
    handleTrackContinue,
    handleTrackCloseModal,
    handleTrackOpenModal,
  } = useAppTrackingHook(ProofIncomeLandingTrackingHandlers);

  useEffect(() => {
    handleTrackView();
  }, []);

  return {
    ...ProofIncomeLandingHandlers({
      handleTrackSelectMethod,
      handleTrackConfirm,
      setSelectedMethod,
      setProofIncomeIdentificationId,
      setProofIncomeState,
      setIframeUrl,
      setError,
    }),
    handleTrackContinue,
    handleTrackCloseModal,
    handleTrackOpenModal,
    methods,
    selectedMethod,
  };
};

export { useProofIncomeLandingHook };
